import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Paper, Button } from "@mui/material";

export const TranslationDebugger: React.FC = () => {
  const { t, i18n } = useTranslation(["common", "dashboard", "test"]);

  const testKeys = [
    "appTitle",
    "welcome",
    "test:page.title",
    "navigation.events",
    "roles.organizer",
  ];

  const testNamespaces = [
    { ns: "common", key: "appTitle" },
    { ns: "dashboard", key: "welcome" },
    { ns: "test", key: "page.title" },
    { ns: "common", key: "navigation.events" },
    { ns: "common", key: "roles.organizer" },
  ];

  return (
    <Paper sx={{ p: 3, mb: 3, bgcolor: "grey.50" }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        🔍 Отладка переводов
      </Typography>

      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Текущий язык: <strong>{i18n.language}</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Доступные языки: <strong>{i18n.languages?.join(", ")}</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Namespaces:{" "}
          <strong>
            {Array.isArray(i18n.options.ns)
              ? i18n.options.ns.join(", ")
              : i18n.options.ns}
          </strong>
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Тест ключей (defaultNS):
        </Typography>
        {testKeys.map((key) => (
          <Box key={key} sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary">
              {key}:
            </Typography>
            <Typography variant="body2" sx={{ ml: 1 }}>
              "{t(key)}"
            </Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Тест с явными namespace:
        </Typography>
        {testNamespaces.map(({ ns, key }) => (
          <Box key={`${ns}:${key}`} sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary">
              {ns}:{key}:
            </Typography>
            <Typography variant="body2" sx={{ ml: 1 }}>
              "
              {String(
                t(key, {
                  ns: ns as
                    | "common"
                    | "events"
                    | "tasks"
                    | "widgets"
                    | "dashboard"
                    | "notifications"
                    | "documents"
                    | "support"
                    | "test",
                }),
              )}
              "
            </Typography>
          </Box>
        ))}
      </Box>

      <Button
        variant="outlined"
        size="small"
        onClick={() => {
          if (process.env["NODE_ENV"] === "development") {
            console.log("🔍 Debug: Current i18n state:", {
              language: i18n.language,
              languages: i18n.languages,
              namespaces: i18n.options.ns,
              resources: i18n.store.data,
              currentResources: i18n.store.data[i18n.language],
            });
          }
        }}
      >
        Логировать состояние в консоль
      </Button>
    </Paper>
  );
};

export default TranslationDebugger;
